import React from 'react'

interface ChatInspirationIconProps {
  size?: number
  color?: string
}

const ChatInspirationIcon: React.FC<ChatInspirationIconProps> = ({
  size = 24,
  color = 'white',
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_437_15170)">
        <rect
          width="24"
          height="24"
          rx="12"
          transform="matrix(1 0 0 -1 0 24)"
          fill="black"
          fillOpacity="0.3"
        />
        <path
          d="M13.373 18.0088C13.5681 18.049 13.7148 18.2218 13.7148 18.4287C13.7146 18.6355 13.568 18.8086 13.373 18.8486L13.2861 18.8574H10.7148C10.4783 18.8574 10.2864 18.6652 10.2861 18.4287C10.2861 18.192 10.4782 18 10.7148 18H13.2861L13.373 18.0088ZM12 5.14258C14.8402 5.14258 17.1434 7.44496 17.1436 10.2852C17.1436 12.3603 15.9134 14.1471 14.1436 14.96V16.2852C14.1436 16.7585 13.7595 17.1426 13.2861 17.1426H10.7148C10.2415 17.1426 9.85742 16.7585 9.85742 16.2852V14.96C8.08738 14.1472 6.85742 12.3604 6.85742 10.2852C6.85757 7.44506 9.1599 5.14273 12 5.14258ZM11.1123 13.0557C10.9854 13.3096 11.0881 13.618 11.3418 13.7451C11.5958 13.872 11.9052 13.7696 12.0322 13.5156L11.1123 13.0557ZM12.6943 8.12988C12.4812 8.00199 12.2125 8.04727 12.0508 8.22363L11.9883 8.30664L10.7021 10.4492C10.6068 10.6081 10.605 10.8065 10.6963 10.9678C10.7876 11.1287 10.9585 11.2285 11.1436 11.2285H12.0254L11.1123 13.0557L11.5723 13.2852L12.0322 13.5156L13.3174 10.9443C13.3971 10.785 13.3885 10.5949 13.2949 10.4434C13.2012 10.2921 13.0354 10.2003 12.8574 10.2002H12.0518L12.8701 8.83594C13.0162 8.59251 12.9376 8.27612 12.6943 8.12988Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_437_15170">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ChatInspirationIcon
